export const isOg = (id: number) => {
  return id < 500;
};
